module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "dark": "",
      "app": ""
    }
  }, [_c('v-card', {
    staticClass: "flex",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm._v("\n      © 2019 — Up ski & mountain guides\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20aaee03","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = Sxvo
// module chunks = 1